<template>
  <section>
    <div id="footer" class="footer text-lg-left">
      <div class="container">
        <div class="row mb-10">
          <div class="col-12">
            <!-- Logo -->

            <!-- Logo end -->
          </div>
        </div>
        <div class="row mb-30" style="padding-top:15px">
          <!-- footer Links -->
          <div class="col-12 col-lg-8 mb-30" >
            <h4 class="bold mb-30">Kontakt</h4>
            <div class="row">
              <div class="col-2">
                <img src="../assets/logo.png" alt="logo" width="85px">
              </div>
              <div class="col-10">
                <ul>
                  <li>{{settings.contact1}}</li>
                  <li>{{settings.contact2}}</li>
                  <li>{{settings.contact3}}</li>
                  <li>{{settings.contact4}}</li>
                  <li>{{settings.contact5}}</li>
                </ul>
              </div>
            </div>

          </div>
          <!-- footer links end -->

          <!-- footer links -->
          <div class="col-12 col-lg-4 mb-30">
            <h4 class="bold mb-30">Links</h4>
            <ul>
              <li><a href="/gdpr">Datenschutz</a></li>
              <li><a href="/imprint">Impressum</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/blog">Artikel</a></li>
            </ul>
          </div>
          <!-- footer links end -->
          <!-- Copy -->
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <p class="light opas copy mb-15">{{settings.footerLine}}</p>
          </div>
          <!-- Copy end -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {

      }
    },
    computed:{
      settings(){
        return this.$store.getters.settings();
      },
      baseUrl(){
        return this.$store.getters.baseUrl();
      }
    },
    props: [],
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    -webkit-box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);
    box-shadow: 0 2px 4px 0 rgba(20, 20, 40, 0.10);

/*
    position:absolute;
    bottom: 0;
    width: 100%;    
*/
  }

  /* footer logo */

  .footer-brand {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    color: #F7F7FC;
    letter-spacing: 1px;
    width: 70px;
    height: 70px;
    padding: 0;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .footer-brand:hover {
    text-decoration: none;
    color: #F7F7FC;
  }

  .footer-brand img {
    width: 60px;
    margin: 7px 30px 10px 15px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  /* footer lists */

  .footer ul {
    padding: 0;
  }

  .footer ul li {
    list-style-type: none;
  }

  .footer ul li a {
    display: block;
    padding-bottom: 10px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #F7F7FC;
    opacity: .8;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .footer ul li a:hover {
    padding-left: 5px;
    text-decoration: none;
    opacity: 1;
  }
  /* copyright */

  .copy {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 2px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .copy a,
  .copy a:hover {
    color: #F7F7FC;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue